// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/global.css'
import '../static/css/my_style.css'
import 'element-ui/lib/theme-chalk/display.css';

import adminApi from './util/common.js';
import cookie from './util/cookie.js';

import UploadPicture from "./components/UploadPicture";
import SiteLevelTag from "./components/SiteLevelTag";


// 全局设置所有 Dialog 点击遮罩层不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;


Vue.component('UploadPicture', UploadPicture)
Vue.component('SiteLevelTag', SiteLevelTag)
Vue.use(ElementUI);
//引入vuex
import store from './store'

/*引入资源请求插件*/
// import VueResource from 'vue-resource'

/*使用VueResource插件*/
// Vue.use(VueResource)

//定义全局变量
Vue.prototype.adminApi = adminApi;
Vue.prototype.cookie = cookie;

//eventbus
Vue.prototype.eventBus=new Vue()

import axios from 'axios';

// 请求基准路径
axios.defaults.baseURL = '/admin';

// 请求拦截（配置发送请求的信息）-------------------
axios.interceptors.request.use(function (config) {
    // 处理请求之前的配置
    const token = sessionStorage.getItem('admin_token')||'';
    var is_login = config.url.indexOf('login') == -1 ? false : true;
    if (!is_login) {
         config.headers['token'] = token;
    }
    return config;

}, function (error) {
    // 请求失败的处理
    return Promise.reject(error);
});

// 响应拦截（配置请求回来的信息）-------------------
axios.interceptors.response.use(function (response) {
    if (response.data) {
        return response.data
    } else {
        return response;
    }
}, function (error) {
    // 处理响应失败
    // console.log(error.response);
    Vue.prototype.$message.error(error.response.data.msg || error.response.data.message || error.response.data);
    if (error.response) {
        return Promise.reject(error.response.data);
    }
});
Vue.prototype.axios = axios;




// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/Login' || to.path === '/map') return next()
    const token = sessionStorage.getItem('admin_token')
    if (!token) return next('/Login')
    next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})
app.$devtools = true;



// WEBPACK FOOTER //
// ./src/main.js